export const STOCK_RESERVE_LIST_REQUEST = "STOCK_RESERVE_LIST_REQUEST";
export const STOCK_RESERVE_LIST_SUCCESS = "STOCK_RESERVE_LIST_REQUEST_SUCCESS";
export const STOCK_RESERVE_CREATE_REQUEST = "STOCK_RESERVE_CREATE_REQUEST";
export const STOCK_RESERVE_DETAIL_REQUEST = "STOCK_RESERVE_DETAIL_REQUEST";
export const STOCK_RESERVE_EDIT_REQUEST = "STOCK_RESERVE_EDIT_REQUEST";
export const STOCK_RESERVE_ARCHIVE_REQUEST = "STOCK_RESERVE_ARCHIVE_REQUEST";
export const STOCK_RESERVE_DELETE_REQUEST = "STOCK_RESERVE_DELETE_REQUEST";
export const STOCK_RESERVE_UNARCHIVE_REQUEST = "STOCK_RESERVE_UNARCHIVE_REQUEST";

export const STOCK_RESERVE_SUBMIT_REQUEST = "STOCK_RESERVE_SUBMIT_REQUEST";
export const STOCK_RESERVE_APPROVE_REQUEST = "STOCK_RESERVE_APPROVE_REQUEST";
export const STOCK_RESERVE_REJECT_REQUEST = "STOCK_RESERVE_REJECT_REQUEST";
export const STOCK_RESERVE_PROCESS_REQUEST = "STOCK_RESERVE_PROCESS_REQUEST";
export const STOCK_RESERVE_RELEASE_REQUEST = "STOCK_RESERVE_RELEASE_REQUEST";

export const STOCK_RESERVE_CREATE_FORM_NAME = "createStockReserve";
export const STOCK_RESERVE_EDIT_FORM_NAME = "editStockReserve";
export const STOCK_RESERVE_ITEM_ARRAY_FIELD_NAME = "stockReserveItems";

export const STOCK_RESERVE_STATUS_DRAFT = 1;
export const STOCK_RESERVE_STATUS_DRAFT_TITLE = "Draft";
export const STOCK_RESERVE_STATUS_SUBMITTED = 2;
export const STOCK_RESERVE_STATUS_SUBMITTED_TITLE = "Submitted";
export const STOCK_RESERVE_STATUS_APPROVED = 3;
export const STOCK_RESERVE_STATUS_APPROVED_TITLE = "Approved";
export const STOCK_RESERVE_STATUS_REJECTED = 4;
export const STOCK_RESERVE_STATUS_REJECTED_TITLE = "Rejected";
export const STOCK_RESERVE_STATUS_PROCESSED = 5;
export const STOCK_RESERVE_STATUS_PROCESSED_TITLE = "Processed";
export const STOCK_RESERVE_STATUS_RELEASED = 6;
export const STOCK_RESERVE_STATUS_RELEASED_TITLE = "Released";

export const STOCK_RESERVE_STATUS = [
  { id: STOCK_RESERVE_STATUS_DRAFT, name: STOCK_RESERVE_STATUS_DRAFT_TITLE },
  { id: STOCK_RESERVE_STATUS_SUBMITTED, name: STOCK_RESERVE_STATUS_SUBMITTED_TITLE },
  { id: STOCK_RESERVE_STATUS_APPROVED, name: STOCK_RESERVE_STATUS_APPROVED_TITLE },
  { id: STOCK_RESERVE_STATUS_REJECTED, name: STOCK_RESERVE_STATUS_REJECTED_TITLE },
  { id: STOCK_RESERVE_STATUS_PROCESSED, name: STOCK_RESERVE_STATUS_PROCESSED_TITLE },
  { id: STOCK_RESERVE_STATUS_RELEASED, name: STOCK_RESERVE_STATUS_RELEASED_TITLE },
];

export const STOCK_RESERVE_SUBMIT_RULES = {
  employeeId: {
    required: true,
  },
  stockReserveItems: {
    type: "arrayInline",
    message: "Please add at least one item.",
    required: true,
    subFields: [
      { name: "itemId" },
      { name: "quantity", type: "number" },
    ],
  },
};

export const READ_STOCK_RESERVE = 278000;
export const CREATE_STOCK_RESERVE = 278001;
export const UPDATE_STOCK_RESERVE = 278002;
export const DELETE_STOCK_RESERVE = 278003;
export const ARCHIVE_STOCK_RESERVE = 278004;
export const UNARCHIVE_STOCK_RESERVE = 278005;
export const BATCH_DELETE_STOCK_RESERVE = 278006;
export const SUBMIT_STOCK_RESERVE = 278011;
export const APPROVE_STOCK_RESERVE = 278012;
export const REJECT_STOCK_RESERVE = 278013;
export const PROCESS_STOCK_RESERVE = 278014;
export const RELEASE_STOCK_RESERVE = 278015;
